exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "body{height:100vh;font:62.5% Roboto,sans-serif}*{box-sizing:border-box;font-size:14px;font-family:Roboto,sans-serif}.app{height:100vh;background-color:#f1f1f1;display:flex;flex-direction:column;justify-content:center;align-items:center}.title{height:10vh;transition:all .5s linear}.title h1{font-weight:bolder;color:#888;letter-spacing:2px}h2{text-align:center}.container{width:90vw;height:70vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/app.scss
// module id = 695
// module chunks = 0